import { RadioGroupInput } from '@framework/form/inputs/RadioGroupInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { yup } from '@framework/validation/initYup.ts';

export enum SensitiveType {
  Personal = 'personal',
  Sensitive = 'sensitive',
  None = 'none',
}

export const sensitiveTypeValidator = yup
  .string()
  .oneOfEnum(SensitiveType)
  .notRequired()
  .default(SensitiveType.None)
  .label('Tipo di dati sensibili');

export interface ISensitiveDataTypeConfigComponentProps {
  name: string;
}

export function SensitiveDataTypeConfigComponent(
  props: ISensitiveDataTypeConfigComponentProps,
) {
  return (
    <FormItem
      name={`${props.name}.sensitiveType`}
      label="Tipologia di dati sensibili raccolti nel campo"
    >
      <RadioGroupInput
        defaultValue={SensitiveType.None}
        name={`${props.name}.sensitiveType`}
        options={[
          { label: 'Nessuno', value: SensitiveType.None },
          { label: 'Dati Personali', value: SensitiveType.Personal },
          { label: 'Dati Sensibili', value: SensitiveType.Sensitive },
        ]}
      />
    </FormItem>
  );
}
